import { isChromium, isWebView2, isWinNative } from '~/utils/runEnvironmentUtil';

const messageListenerMap = {};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function off(type, callback) {
  if (!isWinNative()) return;
  // window.doorayUnregister(type, callback);
}

function on(type, callback) {
  if (!isWinNative()) return;

  if (isChromium()) {
    window.doorayRegister(type, callback);
  } else if (isWebView2()) {
    if (type === 'bothView:screenCapture') {
      window.chrome.webview.addEventListener('sharedbufferreceived', (event) => {
        const buffer = event.getBuffer();
        callback(buffer);
        window.chrome.webview.releaseBuffer(buffer);
      });
      return;
    }

    if (messageListenerMap[type]) {
      window.chrome.webview.removeEventListener('message', messageListenerMap[type]);
    }

    function transformData(data) {
      if ('contents' in data && data.contents) {
        return data.contents;
      }
      return data;
    }

    function handleMessage(event) {
      if (type !== event.data.type) return;

      const data = transformData(event.data);
      callback(data);
    }

    messageListenerMap[type] = handleMessage;
    window.chrome.webview.addEventListener('message', handleMessage);
  }
}

function send(params) {
  if (isChromium()) {
    window.doorayNotify({ request: JSON.stringify(params) });
  } else if (isWebView2()) {
    window.chrome.webview.postMessage(JSON.stringify(params));
  }
}

const winNativeService = {
  on,
  off,
  send,
};
export default winNativeService;
